
import Animation from 'Scripts/classes/Animation'
//Vendor
import gsap from 'gsap'

export default class extends Animation {
  constructor({ element }) {
    // console.log(element)
    super({
      element
    })
  }

  animateIn() {
    super.animateIn()

    gsap.to(this.element, {
      opacity: 1,
      visibility: 'visible',
      duration: 1,
      overwrite: "auto"
    })
  }

  animateOut() {
    super.animateOut()

    gsap.set(this.element, {
      opacity: 0,
      visibility: 'hidden'
    })
  }

}
